/* tslint:disable */
/* eslint-disable */
/**
 * Property Management API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 3.0.2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface PoiInName
 */
export interface PoiInName {
    /**
     * 
     * @type {string}
     * @memberof PoiInName
     */
    name: string;
}

export function PoiInNameFromJSON(json: any): PoiInName {
    return PoiInNameFromJSONTyped(json, false);
}

export function PoiInNameFromJSONTyped(json: any, ignoreDiscriminator: boolean): PoiInName {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
    };
}

export function PoiInNameToJSON(value?: PoiInName | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
    };
}


